import type { MenuTreeNode } from '../types/menu-tree'

// Treat backend menu tree as active whenever it is present.
// Explicit user-level denies can legitimately produce all canView=false, and those
// should not fall back to legacy/static permissions.
export const hasAnyMenuTreeCanView = (tree?: MenuTreeNode[]): boolean => {
  return Array.isArray(tree) && tree.length > 0
}
